module.exports = __webpack_public_path__ + "static/media/japan-bg.6a639271.mp3";